export const siteConfig = {
  name: "lab0",
  domain: "lab0.ai",
  tagline: "AI Agent for Enterprise Software Implementation",
  email: "founders@lab0.ai",
  linkedin: "https://www.linkedin.com/in/lakshya-gupta-0030771ba/",
  demoUrl: "https://cal.com/lakshg/30min",
};

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Problems", href: "/problems" },
  { label: "Jobs", href: "/jobs" },
];

export const implementsMenu = [
  { label: "Adobe" },
  { label: "ServiceNow", href: "/servicenow", isNew: true },
  { label: "Oracle", comingSoon: true },
  { label: "SAP", comingSoon: true },
];

export const problemContent = {
  heading: "Enterprise software is sold like a product but deployed like a consulting project.",
  description:
    "The delays are predictable: customer context is scattered, delivery teams rebuild the same artifacts, and every decision gets rediscovered across meetings.",
  points: [
    {
      stat: "3\u201312 mo",
      title: "Time to go live",
      description:
        "Systems like ERP, ITSM, identity, security, and data platforms take months to deploy after contracts are signed.",
    },
    {
      stat: "80%",
      title: "Repetitive work",
      description:
        "Implementation teams repeatedly perform the same process for each new customer, even though patterns are similar across deployments.",
    },
    {
      stat: "Manual",
      title: "Fragmented process",
      description:
        "Understanding environments, mapping processes, designing policies, planning integrations, migrating data\u2014all done manually across scattered channels.",
    },
    {
      stat: "40\u201350%",
      title: "Customer-side delay",
      description:
        "Approvals, missing data, firewall changes, and shared internal bandwidth stall the work after the deal is signed.",
    },
    {
      stat: "$70\u201380k",
      title: "Services drag",
      description:
        "Customers routinely pay large services costs on top of license spend before they see production value.",
    },
    {
      stat: "4+",
      title: "Handoff chain",
      description:
        "Discovery, architecture, implementation, validation, and customer teams each carry partial context.",
    },
  ],
  consequences: [
    "Vendors carry large, expensive service teams",
    "Customers wait months to realize value",
    "Revenue locked behind long onboarding cycles",
    "Slow rollouts, hidden costs, unpredictable outcomes",
  ],
};

export const solutionContent = {
  heading: "Productize the implementation itself.",
  description:
    "Instead of hiring more implementation specialists, ship a standardized AI-assisted workflow that compresses deployment from months to weeks.",
  capabilities: [
    {
      title: "Async Context Gathering",
      description:
        "Agents gather context across communication channels\u2014Slack, email, docs\u2014without blocking your team.",
      terminal: "lab0 gather --channels slack,email,confluence",
    },
    {
      title: "Auto-Configure & Deploy",
      description:
        "Generate deployment plans, configure integrations, design policies, and customize workflows automatically.",
      terminal: "lab0 configure --integrations sso,hris,ticketing",
    },
    {
      title: "Learn & Improve",
      description:
        "Each deployment improves the system. The agent learns from previous rollouts and optimizes future implementations.",
      terminal: "lab0 optimize --from-history --encode-best-practices",
    },
  ],
};

export const contactContent = {
  heading: "Let\u2019s talk.",
  description:
    "We\u2019re building AI agents that make enterprise software truly self-serve. If your implementation timelines are measured in months, we should talk.",
  email: "founders@lab0.ai",
  team: [
    {
      name: "Lakshya Gupta",
      url: "https://www.linkedin.com/in/lakshya-gupta-0030771ba/",
    },
    {
      name: "Sujay Srivastava",
      url: "https://www.linkedin.com/in/sujaysriv/",
    },
    {
      name: "Onkar Borade",
      url: "https://www.linkedin.com/in/onkar-borade/",
    },
  ],
};

export const blogContent = {
  heading: "Field notes from enterprise implementation.",
  description:
    "Short operating notes on why deployments stall, how teams keep context alive, and where agents can take repeatable work off the critical path.",
  posts: [
    {
      title: "Why the signed contract is not the start line",
      description:
        "The deployment clock starts before procurement finishes. The handoff only works when sales, security, data owners, and implementation agree on what will be true on day one.",
      href: "#contact",
    },
    {
      title: "The hidden cost of customer-side blockers",
      description:
        "Most implementation drag comes from missing access, unresolved ownership, and data that does not match the target system. Agents can surface those blockers before the kickoff call.",
      href: "#contact",
    },
    {
      title: "A deployment runbook should learn every time",
      description:
        "Every rollout produces decisions, exceptions, and artifacts. The next customer should not pay for that knowledge to be rediscovered from scratch.",
      href: "#contact",
    },
  ],
};

export const footerContent = {
  copyright: `\u00A9 ${new Date().getFullYear()} lab0.ai`,
};
